import { AllUsers, Clickable, Col, Row, Text } from 'components';
import { Api, theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SuggestionItem } from './';

const Suggestions = ({
  data,
  title,
  secondaryTitle,
  subtitleText,
  marg,
  allUsersType,
  showFollowing
}) => {
  const { athletesOnApp, type, sports, fansOnApp } = useSelector((state) => state.browse),
    [filtered, setFiltered] = useState(null),
    [visible, setVisible] = useState(false),
    navigate = useNavigate(),
    dispatch = useDispatch(),
    { removedSuggestions, following, _id } = useSelector((state) => state.user),
    { isMobile } = useSelector((state) => state.appState),
    dataLength = useRef(0),
    fetching = useRef(false),
    endReached = useRef(false),
    { t } = useTranslation();

  useEffect(() => {
    setFiltered(
      data?.filter((x) => {
        if (!x?._id) return false;

        const hasName = x.name;
        const isntSelf = x._id !== _id;
        const filteredFollowing = !allUsersType
          ? !following.includes(x._id)
          : true || showFollowing;
        const filteredRemoved = !allUsersType ? !removedSuggestions?.includes(x._id) : true;

        return hasName && isntSelf && filteredFollowing && filteredRemoved;
      })
    );
  }, [data]);

  useEffect(() => {
    if (!filtered) return;
    dataLength.current = data?.length || 0;
  }, [filtered]);

  function handleVisible() {
    setVisible(!visible);
  }

  function removeSuggestion(user) {
    dispatch({
      type: 'REMOVE_SUGGESTION',
      payload: user._id
    });

    Api.post('/users/removeSuggestion', { userId: user._id });
  }

  async function fetchMoreData() {
    if (fetching.current || !filtered || endReached.current) return;
    fetching.current = true;

    const res = await Api.post('/browse/getMoreUsers', {
      type: allUsersType,
      skip: dataLength.current
    });

    if (!res) return (fetching.current = false);
    if (res.length < 30) return (endReached.current = true);

    dispatch({
      type: allUsersType === 'fan' ? 'ADD_FANS_BROWSE' : 'ADD_ATHLETES_BROWSE',
      payload: res
    });

    fetching.current = false;
  }

  if (!filtered?.length) return null;

  return (
    <Col wid={isMobile ? '100vw' : '100%'} center marg={marg}>
      <Text b2 med col={theme.GREY_70}>
        {secondaryTitle}
      </Text>

      <Row between center wid="100%">
        <Text h2 marg={isMobile ? '0 0 0 16px' : '0'}>
          {title}
        </Text>

        {!isMobile && filtered.length > 4 && (
          <Clickable onClick={handleVisible}>
            <Text b2 bold>
              {t('common.seeAll')}
            </Text>
          </Clickable>
        )}
      </Row>

      <Row marg="16px 0 0" start gap="24px" scrollY={isMobile}>
        {filtered.slice(0, isMobile ? filtered.length : 4).map((x, index) => (
          <Row
            key={index}
            marg={
              index === 0
                ? isMobile
                  ? '0 0 0 16px'
                  : '0'
                : index === filtered.length - 1
                  ? '0 16px 0 0'
                  : '0'
            }
          >
            <SuggestionItem
              key={index}
              item={x}
              navigate={navigate}
              subtitleText={subtitleText}
              removeSuggestion={removeSuggestion}
              allUsers={!!allUsersType}
            />
          </Row>
        ))}

        <AllUsers visible={visible} closeModal={handleVisible} type={allUsersType} />
      </Row>
    </Col>
  );
};

export default Suggestions;
